:host {
  @include reset-host;
}

:host .loading-icon {
  @include z-index('base');
  position: relative;

  width: rem(40);
  height: rem(40);

  border-radius: 50%;

  animation: loading-spin 0.7s linear infinite;

  @each $color-key, $color-value in $theme-colors {
    &.is-#{$color-key} {
      border: 2px solid map-get($color-value, light);
      border-top-color: transparent;
    }
  }
}

@keyframes loading-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
